<template>
<div>
    <v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Captain Profile"
            :length="0"
            btn_txt=""
            btn_to="" />

        <!-- AVATAR -->
        <div class="d-flex justify-center pt-0" v-if="loaded">
            <UserAvatar :photo="user.photo" size="120px" class="elevation-3" style="z-index: 10"/>
        </div> 
        
        <!-- INFO -->
        <v-card max-width="620px" outlined class="mx-auto" style="margin-top:-70px" v-if="loaded">
            <v-btn absolute dark fab top right :color="user.color" @click="letEdit=!letEdit">
                <v-icon color="white" small v-if="!letEdit">fa-pen</v-icon>
                <v-icon color="white" small v-else>fa-times</v-icon>
            </v-btn> 

            <!-- CUSTOMIZE -->
            <v-menu offset-y v-if="letEdit">
                <template v-slot:activator="{ on }">
                    <v-btn absolute dark fab top left small color="purple" v-on="on">
                        <v-icon color="white" small>fa-palette</v-icon>
                    </v-btn> 
                </template>
                <v-color-picker 
                        v-model="color" 
                        @input="setColor"
                        hide-inputs 
                        hide-mode-switch 
                        width="230px"></v-color-picker>
            </v-menu>
            <v-menu offset-y v-if="letEdit">
                <template v-slot:activator="{ on }">
                    <v-btn absolute dark fab top left small class="ml-12" color="blue-grey darken-1" v-on="on">
                        <v-icon color="white" small>fa-swatchbook</v-icon>
                    </v-btn> 
                </template>
                <v-card>
                    <v-card-text>
                        <div class="d-flex">
                            <v-card @click="setTexture(0)" hover :color="user.color">
                                <v-img height="60px" width="60px">
                                    <div class="d-flex justify-center align-center" style="height:100%" v-if="user.texture==0">
                                        <v-icon color="white">fa-check-circle</v-icon>
                                    </div>
                                </v-img>
                            </v-card>
                            <v-card class="ml-2"  @click="setTexture(1)" hover :color="user.color">
                                <v-img :src="require('@/assets/textures/1.png')" height="60px" width="60px">
                                    <div class="d-flex justify-center align-center" style="height:100%" v-if="user.texture==1">
                                        <v-icon color="white">fa-check-circle</v-icon>
                                    </div>
                                </v-img>
                            </v-card>
                            <v-card class="ml-2"  @click="setTexture(2)" hover :color="user.color">
                                <v-img :src="require('@/assets/textures/2.png')" height="60px" width="60px">
                                    <div class="d-flex justify-center align-center" style="height:100%" v-if="user.texture==2">
                                        <v-icon color="white">fa-check-circle</v-icon>
                                    </div>
                                </v-img>
                            </v-card>
                        </div>
                        <div class="d-flex mt-2">
                            <v-card  @click="setTexture(3)" hover :color="user.color">
                                <v-img :src="require('@/assets/textures/3.png')" height="60px" width="60px">
                                    <div class="d-flex justify-center align-center" style="height:100%" v-if="user.texture==3">
                                        <v-icon color="white">fa-check-circle</v-icon>
                                    </div>
                                </v-img>
                            </v-card>
                            <v-card class="ml-2"  @click="setTexture(4)" hover :color="user.color">
                                <v-img :src="require('@/assets/textures/4.png')" height="60px" width="60px">
                                    <div class="d-flex justify-center align-center" style="height:100%" v-if="user.texture==4">
                                        <v-icon color="white">fa-check-circle</v-icon>
                                    </div>
                                </v-img>
                            </v-card>
                            <v-card class="ml-2"  @click="setTexture(5)" hover :color="user.color">
                                <v-img :src="require('@/assets/textures/5.png')" height="60px" width="60px">
                                    <div class="d-flex justify-center align-center" style="height:100%" v-if="user.texture==5">
                                        <v-icon color="white">fa-check-circle</v-icon>
                                    </div>
                                </v-img>
                            </v-card>
                        </div>
                    </v-card-text>
                </v-card>
            </v-menu>

            <!-- NAME AND BIO -->
            <div :style="{backgroundColor: color}">

                <v-img height="170px" :src="require('@/assets/textures/'+user.texture+'A.png')">
                    <div class="headline font-weight-medium text-center white--text" style="padding-top:84px">{{user.name}}</div>
                    
                    <div class="d-flex justify-center align-center white--text">
                        <div class="subtitle-1 text-center" style="line-height:1.2" >
                            <span v-if="user.bio">{{user.bio}}</span>
                            <span v-else style="opacity:.5"><i>- Personal slogan missing -</i></span>
                        </div>
                        <v-btn fab icon class="ml-1" small @click="showEditBio=true" v-if="letEdit">
                            <v-icon small color="white">fa-pen</v-icon>
                        </v-btn>
                    </div> 
                </v-img> 
            </div>  

            <v-divider></v-divider>
            
            <!-- PROFESSION -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY PROFESSION</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="user.profession">
                        <div>{{user.profession}}</div>
                        <v-btn depressed class="accent mt-1" small @click="showEditProfession=true" v-if="letEdit">
                            Edit
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn depressed class="accent" @click="showEditProfession=true">Edit my profession</v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- AGE -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY AGE</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="user.age">
                        <div>{{user.age}}</div>
                        <v-btn depressed class="accent mt-1" small @click="showEditAge=true" v-if="letEdit">
                            Edit
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn depressed class="accent" @click="showEditAge=true">Edit my age</v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- COUNTRY -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY COUNTRY</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="user.country">
                        <div>{{user.country}}</div>
                        <v-btn depressed class="accent mt-1" small @click="showEditCountry=true" v-if="letEdit">
                            Edit
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn depressed class="accent" @click="showEditCountry=true">Edit my country</v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- DESCRIPTION -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY DESCRIPTION</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="user.description">
                        <div>{{user.description}}</div>
                        <v-btn depressed class="accent mt-1" small @click="showEditDescription=true" v-if="letEdit">
                            Edit
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn depressed class="accent" @click="showEditDescription=true">Edit my description</v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- SUPER POWER -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-6" style="font-size:11px">MY SUPER POWER</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-6 px-4">
                    <div v-if="user.superPower">
                        <div>{{user.superPower}}</div>
                        <v-btn depressed class="accent mt-1" small @click="showEditSuperPower=true" v-if="letEdit">
                            Edit
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn depressed class="accent" @click="showEditSuperPower=true">Edit my super power</v-btn>
                    </div>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <!-- MY 5 ATTRIBUTES -->
            <v-row>
                <v-col col="12" sm="6" md="4" style="border-right:1px solid #dbdbdb">
                    <div class="text-center font-weight-medium black--text pt-5" style="font-size:11px">MY MOLECULE</div>
                </v-col>
                <v-col col="12" sm="6" md="8" class="pt-8 pb-4 px-4">
                    <div class="d-flex justify-space-between">
                        <div>
                            <div class="d-flex align-center pl-4">
                                <div>
                                    <div v-if="attributes.length>0">
                                        <div v-for="(att, index) in attributes" :key="att.id">
                                            <span class="mr-1 body-1 font-weight-medium" :style="{color: user.color}">{{index+1}}.</span>
                                            <span class="black--text body-1">{{att}}</span>
                                        </div>
                                    </div>
                                    <div class="caption font-weight-medium grey--text" v-else>NO ATTRIBUTES YET</div>
                                </div>
                            </div>
                            <div class="mt-2">
                                <v-btn text class="ml-n1" :style="{color: user.color}" @click="$router.push('/molecule')">
                                    My molecule
                                    <v-icon right size="12px" :color="user.color">fa-external-link-alt</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <div class="pr-12 mt-4" @click="$router.push('/molecule')" style="cursor:pointer">
                            <v-img :src="require('@/assets/molecule/molecule-center.png')" width="110px"></v-img>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        

        <!-- LOADER -->
        <SendingLoader v-if="!loaded"/>
    </v-card>

    <DiagBio
        :model="showEditBio"
        for="user"
        @cancel="showEditBio=false"
        @changed="changed" />
    
    <DiagSuperPower
        :model="showEditSuperPower"
        @cancel="showEditSuperPower=false"
        @changed="changed" />

    <DiagProfession
        :model="showEditProfession"
        @cancel="showEditProfession=false"
        @changed="changed" />

    <DiagCountry
        :model="showEditCountry"
        @cancel="showEditCountry=false"
        @changed="changed" />

    <DiagAge
        :model="showEditAge"
        @cancel="showEditAge=false"
        @changed="changed" />

    <DiagDescription
        :model="showEditDescription"
        @cancel="showEditDescription=false"
        @changed="changed" />
</div>
</template>

<script>
import Sign from '@/firebase/sign'
import Users from '@/firebase/users'
import Teams from '@/firebase/teams'
import DiagBio from '@/components/core/dialogs/DiagBio'
import DiagSuperPower from '@/components/captain/DiagSuperPower'
import DiagProfession from '@/components/captain/DiagProfession'
import DiagCountry from '@/components/captain/DiagCountry'
import DiagDescription from '@/components/captain/DiagDescription'
import DiagAge from '@/components/captain/DiagAge'
import DiagAttributes from '@/components/core/dialogs/DiagAttributes'
import backgroundUrl from '@/assets/textures/1.png'

export default {
    data: () => ({
        loaded: false,
        showEditBio: false,
        showEditAttributes: false,
        showEditSuperPower: false,
        showEditProfession: false,
        showEditCountry: false,
        showEditAge: false,
        showEditDescription: false,
        letEdit: false,
        team: null,
        tab: 0,
        color: '',
        texture: '',
        backgroundUrl
    }),
    components: {
        DiagBio,
        DiagAttributes,
        DiagSuperPower,
        DiagProfession,
        DiagCountry,
        DiagAge,
        DiagDescription
    },
    computed: {
        attributes() {
            if (this.user.attributes == undefined) return [];

            let tempo = [];
            for(let key in this.user.attributes) {
                tempo.push(this.user.attributes[key])
            }

            return tempo;
        },
    },
    mounted() {
        this.color = this.user.color;
        this.texture = this.user.texture;
        this.init();
    },
    methods: {
        init() {
            this.loaded = true;
        },
        changed() {
            Sign.reInitUser(this.user.uid);
            this.showEditBio = false;
            this.showEditAttributes = false;
            this.showEditSuperPower = false;
            this.showEditProfession = false;
            this.showEditCountry = false;
            this.showEditAge = false;
            this.showEditDescription = false;
        },
        arrayMove (arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        },
        setColor(e) {
            this.$store.dispatch('setColor', e);
            Users.setColor(this.user.uid, e);
        },
        setTexture(num) {
            this.$store.dispatch('setTexture', num);
            Users.setTexture(this.user.uid, num);
        }
    }
}
</script>